import React from 'react'
import styles from './form-row.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const FormRow = ({
  classes,
  children,
  className,
  style,
  small,
  left,
  inline
}) => (
  <div
    style={style}
    className={classNames(classes.row, className, {
      [classes.small]: small,
      [classes.left]: left,
      [classes.inline]: inline
    })}>
    {children}
  </div>
)

export default injectSheet(styles)(FormRow)
